<template>
  <div>Please wait... We are preparing the dashboard</div>
</template>

<script>
export default {
  name: "AuthRedirect",
  created() {
    const token = this.$route.params.token;
    if (token) {
      window.localStorage.setItem("authToken", token);
      this.$router.push({ name: "TeamInbox" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
